// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'iview/dist/styles/iview.css'
import App from './App'
import router from './router'
import Vuex from 'vuex'
Vue.use(Vuex)
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import iView from 'iview'
Vue.use(iView)

// 配置axios请求
import Qs from 'qs'
import axios from 'axios'
Vue.prototype.axios = axios
axios.defaults.baseURL = "http://192.168.10.158:20020"; // 配置baseURL
//axios.defaults.baseURL = "https://saas.hdwbcloud.com/";	// 配置baseURL
if(process.env.NODE_ENV == "production") {
	axios.defaults.baseURL = BASEURL;
}
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['Accept'] = 'application/json';
axios.defaults.transformRequest = [function(data) {
	data = Qs.stringify(data)
	return data;
}];
axios.defaults.transformResponse = [function(data) {
	data = JSON.parse(data)
	// 405登录失效处理
	//	if(data.status==405) {
	//		localStorage.clear();
	//		myVue.$Message.warning({
	//			content: "登录已失效",
	//			onClose: function() {
	//				// 处理登录失效
	//				localStorage.clear();
	//				myVue.$store.state.isShowlogin = true;
	//			}
	//		})
	//	}
	return data;
}];

Vue.config.productionTip = false
const mystore = new Vuex.Store({
	state: {
		api_token: "",
		phone: "",
		nickname: "",
		isShowlogin: false,
		loginType: null,
		//个人用户信息
		personal_api_token: '',
		personal_phone: '',
		personal_nickname: '',
		is_nouser_version: '', //是否无用户版，0有用户版，1无用户版
		system_web_name: '',
		is_haveteam_version: ''
	},
	mutations: {
		updateSystemWebName: function(state) {
			state.system_web_name = sessionStorage.getItem('system_web_name')
		},
		updateIsNouserVersion: function(state) {
			state.is_nouser_version = sessionStorage.getItem('is_nouser_version')
		},
		isHaveteamVersion: function(state) {
			state.is_haveteam_version = sessionStorage.getItem('is_haveteam_version')
		},
		updateToken: function(state) {
			state.api_token = localStorage.getItem("api_token");
			state.nickname = localStorage.getItem("nickname");

			state.personal_api_token = localStorage.getItem("personal_api_token");
			state.personal_nickname = localStorage.getItem("personal_nickname");
		},
		logout: function(state) {
			localStorage.clear();

			state.api_token = '';
			state.nickname = '';

			state.personal_api_token = '';
			state.personal_nickname = '';
		},
		showLogin: function(state, type) {
			if(type) {
				state.loginType = type
			}
			state.isShowlogin = true
		},
		hideLogin: function(state) {
			state.isShowlogin = false
			state.loginType = 1
		}
	},
	getters: {},
	actions: {}
})
/* eslint-disable no-new */
const myVue = new Vue({
	el: '#app',
	router,
	store: mystore,
	components: {
		App
	},
	template: '<App/>'
})

function routeJump(to, from, next){
	if(to.meta.notNeedlogin) {
		next();
	} else {
		if(localStorage.getItem("api_token") || localStorage.getItem("personal_api_token")) {
			if(to.matched[0].path == "/team") {
				//				next();
				// 判断访问路径权限：团队用户
				axios({
						method: 'get',
						url: '/api/teamusers/info',
						params: {
							p: "w",
							api_token: localStorage.getItem("api_token")
						}
					})
					.then(function(res) {
						let o = res.data
						if(o.status == 1) {
							localStorage.setItem("phone", o.data.phone)
							localStorage.setItem("nickname", o.data.nickname)
							myVue.$store.commit("updateToken");
							if(o.data.team_status == 2 || to.path != "/team/order") {
								next();
							} else {
								myVue.$router.push({
									path: '/team/info'
								})
							}
						} else {
							localStorage.removeItem("api_token")
							myVue.$store.commit("showLogin", 2);
						}
					})
					.catch(function(res) {
						console.log(res)
					});
			} else if(to.matched[0].path == "/personal" && localStorage.getItem("personal_api_token")) {
				// 判断访问路径权限：个人用户
				//				next();
				axios({
						method: 'get',
						url: '/api/users/info',
						params: {
							p: "w",
							api_token: localStorage.getItem("personal_api_token")
						}
					})
					.then(function(res) {
						let o = res.data
						if(o.status == 1) {
							localStorage.setItem("phone", o.data.phone)
							localStorage.setItem("nickname", o.data.nickname)
							myVue.$store.commit("updateToken");
							next();
						} else {
							localStorage.removeItem("api_token")
							myVue.$store.commit("showLogin", 1);
						}
					})
					.catch(function(res) {
						console.log(res)
					});
			} else {
				next()
			}
		} else if(sessionStorage.getItem('is_nouser_version') == 1) {
			next()
		} else {
			if(to.matched[0].path == "/team") {
				myVue.$store.commit("showLogin", 2);
			} else {
				myVue.$store.commit("showLogin", 1);
			}

		}
	}
}

/* 路由跳转前，执行 */
router.beforeEach((to, from, next) => {
	next();
})
/* 路由进入时，执行 */
router.beforeResolve((to, from, next) => {
	if(!sessionStorage.getItem('system_web_name')) {
		axios({
				method: 'get',
				url: '/api/yiqing/info',
				params: {
					p: "w"
				}
			})
			.then(function(res) {
				sessionStorage.setItem('system_web_name',res.data.data.system_web_name);
				let timer = setInterval(()=>{
					if(sessionStorage.getItem('system_web_name')){
						window.clearInterval(timer);
						routeJump(to, from, next)
					}
				},100)
			})
	} else {
		routeJump(to, from, next)
	}
})
/* 路由跳转后，执行 */
router.afterEach((to, from) => {
	// 返回顶部
	window.scrollTo(0, 0);
	myVue.$store.commit("hideLogin");
})

// 示例axios请求：post、get
/*
vm.axios({
	method: 'get',
	url: '/api/home/data_list',
	params: {
		p: "",
		user: "",
		pwd: ""
	}
})
.then(function(res){})
.catch(function(res){});
vm.axios({
	method: 'post',
	url: '/api/users/login',
	data: {
		p: "",
		user: "",
		pwd: ""
	}
})
.then(function(res){})
.catch(function(res){});
*/


// WEBPACK FOOTER //
// ./src/main.js